module.exports = __webpack_public_path__ + "img/pridnestrovian_moldovian_republic.b27796d.webp";